import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import DriveThruAffiliateHeader from "../../driveThruAffiliateHeader/driveThruAffiliateHeader.component";
import { useEffect } from "react";
import NavCampaign from "./NavCampaign";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div class="morkBorgFont morkBorgTitleText">
        {/* <p align="center">
          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-barrowcleft.webp"
            alt="Barrowcleft"
          />
        </p> */}
        <p>
          Game about a group of <strong>daring scoundrels</strong> building a{" "}
          <strong>criminal enterprise</strong> in the{" "}
          <strong>haunted streets of industrial-fantasy city of Doskvol</strong>{" "}
          (aka Duskwall or "the Dusk").{" "}
        </p>
        <p>
          Doskvol is locked in <strong>perpetual darkness</strong> due to
          cataclysm that shattered the sun and broke the{" "}
          <strong>Gates of Death</strong> one thousand years ago. City encircled
          with lightning towers to keep out <strong>vengeful spirits</strong>{" "}
          and horrors of the <strong>deathlands</strong>.{" "}
        </p>
        <p>
          The towers are powered by titanic metal ships that{" "}
          <strong>leviathan hunters</strong>
          sail on the <strong>Void Sea</strong> to extract{" "}
          <strong>ectoplasmic blood</strong> from massive demonic horrors.
        </p>
        <p>
          {" "}
          Doskvol is <strong>cold, foggy</strong> and{" "}
          <strong>akin to 1870s industrial revolution</strong> with trains,
          steam boats, printing presses, and simple electrical devices.{" "}
        </p>
        <p>
          <strong>Black smog</strong> everywhere, twisting{" "}
          <strong>alleys</strong>, perpetual
          <strong>darkness</strong>, and criss-crossed with hundreds of{" "}
          <strong>waterways, sewers, and bridges</strong>.
        </p>
        <p>
          {" "}
          It's a <strong>pressure cooker</strong> since you cannot leave the
          city to wait for heat to die down.{" "}
        </p>
        <p>
          <strong>Actions have consequences.</strong>
        </p>

        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDCampaign = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <DriveThruAffiliateHeader
                  gameName="Blades in the Dark"
                  logo={bladesLogo}
                  productUrl="https://www.drivethrurpg.com/en/product/170689/blades-in-the-dark?affiliate_id=844642"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">
                  Blades in the Dark: Introduction
                </h1>
                <p className="lead leadExtra">
                  <NavCampaign />
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <img
                src={sectionDivider}
                style={{ maxHeight: "169px" }}
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <a name="pageTop" href="#pageTop">
                    {" "}
                  </a>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDCampaign;
